import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import TutorialVideo from '@features/tutorial/shared/TutorialVideo';
import OnboardingSlidePager, {
  type OnboardingSlidePagerStep,
} from '../../shared/OnboardingSlidePager';

const EXPLANATION_STEPS = [
  {
    key: 'lead-time',
    description:
      'In the product catalog you can change the lead time and other settings per product separately.',
    videoSrc: '/assets/videos/onboarding/lead-time.mp4',
    ariaLabel: 'How to change settings per product',
  },
  {
    key: 'lead-time-bulk',
    description:
      'You can also update lead time and other settings for multiple products at once.',
    videoSrc: '/assets/videos/onboarding/lead-time-bulk.mp4',
    ariaLabel: 'How to change settings for multiple products',
  },
] as const;

interface ProductCatalogFinishedStepProps {
  onDismiss: () => void;
}

const ProductCatalogFinishedStep: React.FC<ProductCatalogFinishedStepProps> = ({
  onDismiss,
}) => {
  const steps = useMemo<OnboardingSlidePagerStep[]>(
    () =>
      EXPLANATION_STEPS.map((step) => ({
        key: step.key,
        content: ({ active }) => (
          <Stack direction="column" gap={2}>
            <Typography variant="body1" color="text.secondary">
              {step.description}
            </Typography>
            <TutorialVideo
              src={step.videoSrc}
              ariaLabel={step.ariaLabel}
              active={active}
            />
          </Stack>
        ),
      })),
    [],
  );

  return (
    <OnboardingSlidePager
      title="Your product catalog is set up"
      nextLabel="Next"
      doneLabel="View products"
      onComplete={onDismiss}
      steps={steps}
    />
  );
};

export default ProductCatalogFinishedStep;
